import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imgBankmonitorLogoFullWhite from "@img/logos/bankmonitor-white.svg";
import { Button, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class Step1 extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center">
					<img src={imgBankmonitorLogoFullWhite} alt="Bankmonitor" width="164" height="25" loading="lazy" />
					<hr />
					<div className="h1 mb-1 text-uppercase font-weight-black">Zöld lakáshitel kalkulátor</div>
					<div className="h2 mb-0">Spórolj több millió forintot</div>
					<hr />
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<strong className="mt-4 mb-3">Megtudhatod kalkulátorunk segítségével:</strong>
					<List itemStyle="tick" variant="primary">
						<List.Item className="mb-3">
							<strong>Jogosult vagy-e</strong> az októbertől induló zöld lakáshitelre?
						</List.Item>
						<List.Item className="mb-3">
							Igényelhetnél mellé <strong>ingyenes csok-hitelt</strong>?
						</List.Item>
						<List.Item className="mb-3">
							Mennyivel <strong>csökkenne a törlesztőrészleted</strong>, ha kivársz?
						</List.Item>
						<List.Item>
							<strong>Mennyit spórolnál</strong> az új hitelek választásával?
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasPlay} />} className="text-uppercase">
						Kalkuláció indítása
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
